/**
 * URLの検索パラメーターを { キー: バリュー } 型で返します
 * @param urlParamStr location.searchの値 例) urlParamStr="?crewCd=1234&agencyCd=abcd"
 */
export function getSearchParams(urlParamStr: string) {
  const decodedUrlParamStr = decodeURIComponent(urlParamStr);
  const queries = decodedUrlParamStr.replace('?', '');
  let params: {
    [key: string]: string;
  } = {};
  //urlパラメータをオブジェクトにまとめる
  queries.split('&').forEach((param) => {
    const temp = param.split('=');
    //pramsオブジェクトにパラメータを追加
    // TODO JSONでparseできない不正な値が来た場合の処理が必要か？JSON.parse以外の方法も検討
    // TODO 階層構造をどこまでバラすか(既存の外部連携に合わせるか、既存/BB-GINIE,エリア検索で完全別ロジックにするか)
    if (['basicParam', 'customerParam'].includes(temp[0])) {
      params = {
        ...params,
        ...JSON.parse(temp[1]),
      };
    } else {
      params = {
        ...params,
        [temp[0]]: temp[1].startsWith('{') ? JSON.parse(temp[1]) : decodeURI(temp[1]),
      };
    }
  });

  return params;
}

/**
 * Auth0のアサーション情報をURLパラメーターから取得し返します
 * @param urlParamStr BackEndからエンコードされたURLパラメータ
 * crewCd=9014258009&crewName=野中達也&classCd=&postFlg=03&postCd=1010
 */
export function getSearchParamsList(urlParamStr: string) {
  //変数定義
  const shopList: { agencyCd: string; mainShopFlg: boolean }[] = [];
  let params: {
    [key: string]: string;
  } = {};

  const param = decodeURIComponent(urlParamStr).replace('?', '');

  //パラメータごとにキーバリューで取得する。店舗リストの場合は別処理でshopListに値を格納する
  param.split('&').forEach((splitParam) => {
    if (splitParam.indexOf('asmStaffDetailList') === 0) {
      const shopInfoList = splitParam.split(/[=,}]/);
      for (let x = 2; x < shopInfoList.length; x += 5) {
        const agencyCd = shopInfoList[x];
        const mainShopFlg = shopInfoList[x + 2] === '1';
        shopList.push({ agencyCd, mainShopFlg });
      }
      return;
    }

    if (
      splitParam.indexOf('crewCd') === 0 ||
      splitParam.indexOf('crewName') === 0 ||
      splitParam.indexOf('classCd') === 0 ||
      splitParam.indexOf('postFlg') === 0 ||
      splitParam.indexOf('postCd') === 0 ||
      splitParam.indexOf('key') === 0 ||
      splitParam.indexOf('proxyloginowner') === 0
    ) {
      const temp = splitParam.split('=');
      params = {
        ...params,
        [temp[0]]: temp[1],
      };
    }
  });

  return {
    crewCd: params.crewCd || '',
    crewName: params.crewName || '',
    classCd: params.classCd || '',
    postFlg: params.postFlg || '',
    postCd: params.postCd || '',
    key: params.key || '',
    proxyloginowner: params.proxyloginowner || '',
  };
}
